import Icon from '../components/Icon.vue'

Icon.register({
  'birthday-cake': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 384c-28 0-31.3-32-74.5-32-43.4 0-46.8 32-74.8 32-27.7 0-31.5-32-74.8-32-42.8 0-47.2 32-74.5 32-28.1 0-31.2-32-74.8-32-43.5 0-46.7 32-74.8 32v-80c0-26.5 21.5-48 48-48h16v-144h64v144h64v-144h64v144h64v-144h64v144h16c26.5 0 48 21.5 48 48v80zM448 512h-448v-96c43.4 0 46.8-32 74.8-32 28 0 31.3 32 74.8 32 42.8 0 47.2-32 74.5-32 28.1 0 31.2 32 74.8 32 43.4 0 46.8-32 74.8-32 27.5 0 31.3 32 74.5 32v96zM96 96c-17.8 0-32-14.3-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.3 40-32 40zM224 96c-17.8 0-32-14.3-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.3 40-32 40zM352 96c-17.8 0-32-14.3-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.3 40-32 40z'
      }
    ]
  }
})
